import React from 'react';
import { lzCallApi } from '../../../../services/LzApiService';
import PrivateLayout from '../../../layouts/private';
import Container from '@material-ui/core/Container';
import Paper from '@material-ui/core/Paper';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import Typography from '@material-ui/core/Typography';
import CircularProgress from '@material-ui/core/CircularProgress';
import WarningIcon from '@material-ui/icons/Warning';
import UpdateProfileComponent from './update-profile-component';
import UpdateRmaConfigsComponent from './update-rma-configs-component';
import SubscriptionStatusComponent from '../subscription/subscription-status-component';
import { isNull } from 'lodash';
import DealerModel from '../../../../models/dealer';

class DashboardScreen extends React.Component {

    ACCOUNT_STEPS = [
        { label: 'Sign-up' },
        { label: 'Confirm Email' },
        { label: 'Your Profile' },
        { label: 'RMA Configurations', skippedAlert: 'You will not be able to create rma labels without the configs.' },
        { label: 'Subscribe to Plan' },
    ];

    constructor(props) {
        super(props);
        this.state = {
            dealer: null,
            activeStep: 2,
            skippedSteps: {},
        };
    }

    componentDidMount() {
        this.load();
    }

    evalActiveStep(dealer) {
        if (!isNull(dealer.business_name) && dealer.business_name !== '') {
            if (dealer.has_rma_configs) {
                if (dealer.is_subscription_active) {
                    return 5;
                }
                return 4;
            }
            return 3;
        }
        return 2;
    }

    async load() {
        // Make the api call and get the data
        const data = await lzCallApi('dashboard-data');

        // Load data if call was successful
        if (data && data.dealer) {
            const dealer = new DealerModel(data.dealer);
            this.setState({
                dealer: dealer,
                activeStep: this.evalActiveStep(dealer),
            });
        }
    }

    render() {
        const { dealer, activeStep, skippedSteps } = this.state;

        return (
            <PrivateLayout screenTitle="Dealer Dashboard">

                {dealer ?
                    <Container>
                        <Paper elevation={2} style={{ padding: 24 }}>

                            <Typography variant="h6" style={{ textAlign: 'center' }}>Your Account Status</Typography>
                            <Stepper activeStep={activeStep} alternativeLabel variant="outlined">
                                {this.ACCOUNT_STEPS.map((step, dex) => (
                                    <Step key={'step-' + dex}>
                                        {skippedSteps[dex] ?
                                            <StepLabel icon={<WarningIcon />} optional={step.skippedAlert}
                                                className="lz-step-warning">{step.label}</StepLabel>
                                            :
                                            <StepLabel>{step.label}</StepLabel>
                                        }

                                    </Step>
                                ))}
                            </Stepper>

                            {2 === activeStep &&
                                <UpdateProfileComponent inlineWidget allowSkip
                                    onUpdate={() => this.setState({ activeStep: 3 })}
                                    onSkip={() => this.setState({
                                        activeStep: 3,
                                        skippedSteps: Object.assign({}, skippedSteps, { 2: true }),
                                    })}
                                />
                            }

                            {3 === activeStep &&
                                <UpdateRmaConfigsComponent inlineWidget allowSkip
                                    onUpdate={() => this.setState({ activeStep: 4 })}
                                    onSkip={() => this.setState({
                                        activeStep: 4,
                                        skippedSteps: Object.assign({}, skippedSteps, { 3: true }),
                                    })}
                                />
                            }

                            {4 === activeStep &&
                                <SubscriptionStatusComponent inlineWidget />
                            }

                        </Paper>
                    </Container>
                    :
                    <CircularProgress />
                }

            </PrivateLayout>
        );
    }

}

export default DashboardScreen;
